import { render, staticRenderFns } from "./roomGameRanking.vue?vue&type=template&id=79840296&lang=pug&"
import script from "./roomGameRanking.vue?vue&type=script&lang=js&"
export * from "./roomGameRanking.vue?vue&type=script&lang=js&"
import style0 from "./roomGameRanking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports